// Backend key from permissions.json → AI → AskTrovix (premium plan). It shows Ask Trovix and gates every request;
// whether AI is on for the deployment and the school, the user's context and the budgets are the server's decision on
// every request, and the page shows what it answers.
export const ASK_TROVIX_PERMISSIONS = {
  use: "AI.AskTrovix.use",
} as const;
